/* @jsx h */
import { defineComponent, h } from "vue";

export interface ShopOrderStatusPageProps {}

export const ShopOrderStatusPage = defineComponent<ShopOrderStatusPageProps>({
  name: "ShopOrderStatusPage",
  props: [],
  setup() {
    return () => {};
  },
});
